import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { AdminEditorService } from '../../admin.service';
import { GridColumnHelper, EnumToComboValues } from '../utils';
import { PrivacyProfileDetailsSectionHandler } from './details.section';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '..';
import { PrivacyProfileCreateRequest, PrivacyProfileResponse, PrivacyProfileUpdateRequest } from '@key-telematics/fleet-api-client';

@RegisterEntityHandler('privacyprofile')
@Injectable()
export class PrivacyProfileHandler extends EntityHandler<PrivacyProfileResponse> {

    constructor(
        admin: AdminEditorService
    ) {
        super(admin);
    }

    states = ['active', 'deleted'];

    async listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        return this.admin.getCached(`listPrivacyProfiles/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.entities.listPrivacyProfiles(ownerId, false, offset, limit, sort, filter), 3).then((response: EntityListResult) => ({
            ...response,
            type: 'privacyprofile',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.PRIVACYPROFILES'),
        }));
    }

    getEntity(id: string): Promise<PrivacyProfileResponse> {
        return this.admin.getCached(`getPrivacyProfile/${id}`, api => api.entities.getPrivacyProfile(id), 10);
    }

    createEntity(ownerId: string, entity: PrivacyProfileCreateRequest): Promise<PrivacyProfileResponse> {
        entity.ownerId = ownerId;
        return this.admin.applyUpdate(api => api.entities.createPrivacyProfile(entity));
    }

    setEntityState(entity: any, state: string): Promise<any> {
        return this.admin.applyUpdate(api => api.entities.updatePrivacyProfile(entity.id, { state: state as any }));
    }

    getGridIcon(item: PrivacyProfileResponse): string {
        return item.scheduleTriggers && item.scheduleTriggers.length > 0 || item.stateTriggers && item.stateTriggers.length > 0 ? ICONS.privacyprofile : 'exclamation-triangle';
    }

    getGridColumns(_ownerId: string): Promise<IKuiTableCol[]> {
        const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.PRIVACYPROFILE.COLUMNS');
        const columns: IKuiTableCol[] = [
            grid.IconTextColumn('name', 'NAME', this.getGridIcon),
            grid.ComboColumn('state', 'STATE', EnumToComboValues(this.admin.i18n, 'ADMIN.STATES', this.states, ['deleted']), 80),
            grid.TimeAgoColumn('modifiedDate', 'MODIFIED'),
        ];
        return Promise.resolve(columns);
    }

    getEditorSections(ownerId: string, _entity: any): Promise<SectionHandlerGroup<PrivacyProfileResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new PrivacyProfileDetailsSectionHandler(this.admin, ownerId, false),
            ].filter(x => x),
        }]);
    }

    getCreationSections(ownerId: string): Promise<{ entityType: string, entity: PrivacyProfileUpdateRequest, sections: FormSectionHandler<PrivacyProfileResponse, any>[] }> {
        return Promise.resolve({
            entityType: 'privacyprofile',
            entity: {}, // set up some defaults if you want
            sections: [
                new PrivacyProfileDetailsSectionHandler(this.admin, ownerId, true),
            ],
        });
    }

}












